import { API_BASE_URL } from "../config/api";

const PRIORITY_TYPES = ["Home", "Collection"];
const PRIORITY_ORDER = PRIORITY_TYPES.reduce((acc, name, index) => {
  acc[name.toLowerCase()] = index;
  return acc;
}, {});

const sortCategoryTypes = (types) => {
  if (!Array.isArray(types)) return types;
  return [...types].sort((a, b) => {
    const aPriority =
      a?.typeName && PRIORITY_ORDER[a.typeName.toLowerCase()] !== undefined
        ? PRIORITY_ORDER[a.typeName.toLowerCase()]
        : Number.MAX_SAFE_INTEGER;
    const bPriority =
      b?.typeName && PRIORITY_ORDER[b.typeName.toLowerCase()] !== undefined
        ? PRIORITY_ORDER[b.typeName.toLowerCase()]
        : Number.MAX_SAFE_INTEGER;
    if (aPriority !== bPriority) return aPriority - bPriority;
    const aOrder =
      typeof a?.displayOrder === "number" ? a.displayOrder : Number.MAX_SAFE_INTEGER;
    const bOrder =
      typeof b?.displayOrder === "number" ? b.displayOrder : Number.MAX_SAFE_INTEGER;
    if (aOrder !== bOrder) return aOrder - bOrder;
    return (a?.typeName || "").localeCompare(b?.typeName || "");
  });
};

export const categoryTypeService = {
  _readErrorMessage: async (response, fallback) => {
    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
      try {
        const data = await response.json();
        return data?.error || data?.message || fallback;
      } catch (error) {
        return fallback;
      }
    }
    try {
      const text = await response.text();
      return text || fallback;
    } catch (error) {
      return fallback;
    }
  },
  getAllCategoryTypes: async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/categorytypes/allcategorytypes`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return sortCategoryTypes(data);
    } catch (error) {
      console.error("Category type service error:", error);
      throw error;
    }
  },

  addCategoryType: async (typeData) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/categorytypes/addcategorytype`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(typeData),
        }
      );
      if (!response.ok) {
        const errorMessage = await categoryTypeService._readErrorMessage(
          response,
          "Failed to add category type"
        );
        throw new Error(errorMessage);
      }
      return response.json();
    } catch (error) {
      console.error("Category type service error:", error);
      throw error;
    }
  },

  deleteCategoryType: async (id) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/categorytypes/deletecategorytype/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        const errorMessage = await categoryTypeService._readErrorMessage(
          response,
          "Failed to delete category type"
        );
        throw new Error(errorMessage);
      }
      return response.json();
    } catch (error) {
      console.error("Category type service error:", error);
      throw error;
    }
  },
  updateCategoryType: async (id, typeData) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/categorytypes/editcategorytype/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(typeData),
        }
      );
      if (!response.ok) {
        const errorMessage = await categoryTypeService._readErrorMessage(
          response,
          "Failed to update category type"
        );
        throw new Error(errorMessage);
      }
      return response.json();
    } catch (error) {
      console.error("Category type service error:", error);
      throw error;
    }
  },
};
